/**
 * Runtime configuration. /config.js (served next to index.html, generated at deploy time from environment
 * variables, see docker/entrypoint.sh) sets window.__VCONNECT__ before the app loads, so one build can run
 * in any environment without rebuilding.
 */
const injected = (typeof window !== 'undefined' && window.__VCONNECT__) || {};

export const config = {
  env: injected.env || 'development',
  apiBase: (injected.apiBase || '/api/v1').replace(/\/$/, ''),
  razorpayCheckoutUrl: injected.razorpayCheckoutUrl || 'https://checkout.razorpay.com/v1/checkout.js',
  paymentMode: injected.paymentMode || 'razorpay', // razorpay | manual: only changes wording, the server decides
  otpChannel: injected.otpChannel || 'sms', // sms | email
  gstRegistered: injected.gstRegistered !== false && injected.gstRegistered !== 'false', // false = not registered for GST: no GST wording
  recordings: injected.recordings !== false && injected.recordings !== 'false', // false = pilot without a bucket: no recordings are promised
  livekitClientUrl: injected.livekitClientUrl || '',
  supportEmail: injected.supportEmail || 'support@example.com',
  brandName: injected.brandName || 'VConnect',
  companyName: injected.companyName || 'Vignova Technologies Private Limited',
  sentryDsn: injected.sentryDsn || '',
  requestTimeoutMs: Number(injected.requestTimeoutMs) || 20000,
};

/** The server knows how payments, GST, recordings and codes really work; its answer wins over the wording in config.js. */
export function applyServerFeatures(features) {
  if (!features) return;
  if (['razorpay', 'manual'].includes(features.payments)) config.paymentMode = features.payments;
  if (typeof features.gst === 'boolean') config.gstRegistered = features.gst;
  if (typeof features.recordings === 'boolean') config.recordings = features.recordings;
  if (['sms', 'email'].includes(features.otp_channel)) config.otpChannel = features.otp_channel;
}

export const isProduction = config.env === 'production';
